window.addEventListener('load', () => {
  const footermenutitle = document.querySelectorAll('.mobile_only .footer--block .footer--block--heading');
    
  footermenutitle.forEach(ele => {
    ele.addEventListener('click', () => {
      const footermenuwrapper = ele.closest('.footer--block');    
      footermenuwrapper.classList.toggle('active');  
    })
  })
  
  const openChatButton = document.getElementById("openChat");
  openChatButton.addEventListener("click", () => {
    window.fcWidget.open();
  });
});